const ENV_CONFIG_ATTRIBUTES = {
  ENV: 'ENV',
  LANGUAGE: 'LANGUAGE',
  AUTH_CLIENT_ID: 'AUTH_CLIENT_ID',
  AUTH_SCOPES: 'AUTH_SCOPES',
  AUTH_URL: 'AUTH_URL',
  AUTH_BASE_URL: 'AUTH_BASE_URL',
  AUTH_THEME: 'AUTH_THEME',
  DELIVERY_FAQ_LINK: 'DELIVERY_FAQ_LINK',
  TERMSLINK: 'TERMSLINK',
  CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
  GET_STARTED: 'GET_STARTED',
  MAIN_PAGE: 'MAIN_PAGE',
  MINE_SIDER: 'MINE_SIDER',
};

export { ENV_CONFIG_ATTRIBUTES };
